import { CondictionDataService } from './../../../../conditions/shared/condiction-data.service';
import { Forma, TipoControl, Control, ValoresOperacionesControl, BaseControl } from '@app/shared';
import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { CreationValueOperactionFormsService} from './shared/creation-operation-value.forms.service';
import { find } from 'lodash';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-creation-operation-condition-value',
  templateUrl: './creation-operation-condition-value.component.html',
  styleUrls: ['./creation-operation-condition-value.component.scss'],
  providers: [CreationValueOperactionFormsService, CondictionDataService]
})
export class CreationOperationConditionValueComponent implements OnInit, OnDestroy {

  // Define cuando se agrega o se modifica un valor
  @Input() updateOperationValue = false;
  // Contiene la forma principal
  @Input() formPrincipal: Forma;
  // Define el tipo de control actual
  @Input() typeControl: TipoControl;
  // Contiene el formulario del control
  @Input() formulario: Array<Control> = [];
  // Contiene el valor a modificar
  @Input() controlOperationsValueI: ValoresOperacionesControl;
  // String que identifica la accion a realizar
  actionForm = 'Agregar';
  // Forma temporalmete seleccionada
  formSelect = '';
  // Formulario temporalmete seleccionado
  formularioSelected = '';
  // Contiene los controles del formulario
  controls: BaseControl<any>[] = [];
  // Contiene toodas las formas inplicadas en la forma actual e incluyendo esta
  allForms: Array<{key: string, value: string}> = [];
  // Formularios de la forma seleccionada
  formularios: Array<{key: string, value: string}> = [];
  // Campos del formulario seleccionada
  fields: Array<{key: string, value: string}> = [];
  // Contiene la configuracion del valor de la referencia
  controlOperationsValue: ValoresOperacionesControl;
  // Contiene temporalmente la configuracion del valor de la referencia
  tmpControlOperationsValue: ValoresOperacionesControl;
  // Contiene las opciones del formulario de condiciones
  options: any = {};
  // Contiene los formularios anteriormente cargados
  acumulateFormularios: any = {};
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Salida del evento de cerrar el componente de creacion de operaciones
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  // Salida del evento de guardar valores delas operaciones
  @Output() saveOperationValue: EventEmitter<ValoresOperacionesControl> = new EventEmitter();

  constructor(
    private covfs: CreationValueOperactionFormsService,
    private cds: CondictionDataService,
  ) { }

  ngOnInit() {
    if (this.formPrincipal.alias) {
      if (this.formPrincipal.alias) {
        this.allForms.push({
          key: this.formPrincipal.alias,
          value: this.formPrincipal.alias
        });
      }
    }
    if (this.formPrincipal.asociaciones && this.formPrincipal.asociaciones.length) {
      this.formPrincipal.asociaciones.forEach(association => {
        this.allForms.push({
          key: association.aliasAsociacion,
          value: association.aliasAsociacion
        });
      });
    }

    this.options = {
      forms: this.allForms
    };
    // Se valida si es un actualizar o es una nueva configuracion a la referencia
    if (this.updateOperationValue) {
      this.controlOperationsValue = {
        index: this.controlOperationsValueI.index,
        forma: this.controlOperationsValueI.forma,
        formulario: this.controlOperationsValueI.formulario,
        campo: this.controlOperationsValueI.campo,
        valor: this.controlOperationsValueI.valor,
        referencia: this.controlOperationsValueI.referencia,
      };
      if (this.controlOperationsValueI.forma) {
        this.tmpControlOperationsValue = {
          index: this.controlOperationsValueI.index,
          forma: this.controlOperationsValueI.forma,
          formulario: this.controlOperationsValueI.formulario,
          campo: this.controlOperationsValueI.campo,
          valor: this.controlOperationsValueI.valor,
          referencia: this.controlOperationsValueI.referencia,
        };
        this.actionForm = 'Modificar';
        this.formSelect = this.tmpControlOperationsValue.forma;
        this.formularioSelected = this.tmpControlOperationsValue.formulario;
        // Primero se carga los formularios de la forma asociada seleccionada para posteriormente consultar sus campos
        this.getFormulariosForm(false);
      } else {
        this.controls = this.covfs.getOperaction(
          this.ngSelectTpl,
          this.options,
          this.typeControl,
          this.controlOperationsValue
        );
      }
    } else {
      this.controls = this.covfs.getOperaction(this.ngSelectTpl, this.options, this.typeControl);
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Emite el evento de cierre del componente
   *
   * @memberof CreationOperationValueComponent
   */
  closeComponent() {
    this.close.emit(true);
  }

  /**
   * Guarda el valor de la referencia
   *
   * @param {*} data
   * @memberof CreationOperationValueComponent
   */
  save(data: any) {
    if (data.cboAplicaForma === 'Formulario') {
      this.controlOperationsValue = {
        index: this.updateOperationValue ? this.controlOperationsValueI.index : null,
        forma: data.cboForm,
        formulario: data.cboFormulario,
        campo: data.cboField,
        valor: null,
        referencia: data.txtReferencia,
      };
    } else {
      let valor = null;
      if (this.typeControl.nombre === 'ngSelect' || this.typeControl.nombre === 'number') {
        if (data.txtValor && Number(data.txtValor)) {
          valor = Number(data.txtValor);
        } else if (data.txtValor) {
          valor = data.txtValor;
        }
      } else {
        if (data.txtValor) {
          valor = data.txtValor;
        }
      }
      this.controlOperationsValue = {
        index: this.updateOperationValue ? this.controlOperationsValueI.index : null,
        forma: null,
        formulario: null,
        campo: null,
        valor: valor,
        referencia: data.txtReferencia,
      };
    }
    if (!data.txtReferencia) {
      if (
        this.typeControl.nombre === 'ngSelect' ||
        this.typeControl.nombre === 'email' ||
        this.typeControl.nombre === 'checkbox'
      ) {
        this.controlOperationsValue.referencia = 'valor';
      }
    }
    this.saveOperationValue.emit(this.controlOperationsValue);
  }

  /**
   * Controla los cambios de el formulario cargando respectivamente los selects y sus opciones correspondientes
   *
   * @param {*} data
   * @memberof CreationOperationValueComponent
   */
  changeForm(data: any) {
    if (data.change) {
      this.tmpControlOperationsValue = {
        forma: data.change.cboForm,
        formulario: data.change.cboFormulario,
        campo: data.change.cboField,
        valor: data.change.txtValor,
        referencia: data.change.txtReferencia,
      };
      this.tmpControlOperationsValue['tipoValor'] = data.change.cboAplicaForma;
      if (data.change.cboAplicaForma) {
        if (this.formSelect !== data.change.cboForm) {
          this.formSelect = data.change.cboForm;
          this.tmpControlOperationsValue.formulario = null;
          this.tmpControlOperationsValue.campo = null;
          this.formularioSelected = '';
          this.getFormulariosForm();
        } else if (this.formularioSelected !== data.change.cboFormulario) {
          this.formularioSelected = data.change.cboFormulario;
          this.tmpControlOperationsValue.campo = null;
          this.getFieldForm();
        }
      } else {
        this.formSelect = '';
        this.formularioSelected = '';
      }

    }
  }

  /**
   * Consulta los formularios de la forma seleccionada
   *
   * @private
   * @param {boolean} [update=true]
   * @memberof CreationOperationValueComponent
   */
  private getFormulariosForm(update: boolean = true) {
    this.formularios = [];
    delete this.options['formularios'];
    delete this.options['field'];
    if (this.formPrincipal.alias === this.formSelect) {
      this.formPrincipal.sub_formas.forEach(form => {
        if (form.alias &&
            form.alias !== '' &&
            (!form.tabla ||
             (this.typeControl.nombre === 'number' ||
              this.typeControl.nombre === 'text' ||
              this.typeControl.nombre === 'textarea'
             )
            )
        ) {
          this.formularios.push({
            key: form.alias,
            value: form.alias
          });
        }
      });
      this.options['formularios'] = this.formularios;
      if (update) {
        this.refreshFormCondiction();
      } else {
        this.getFieldForm();
      }
    } else {
      const association = find(this.formPrincipal.asociaciones, {aliasAsociacion: this.formSelect});
      if (association) {
        const formularioSeleted: Forma = this.acumulateFormularios[this.formSelect];
        if (!formularioSeleted) {
          this.cds.getForm(association.idForma).subscribe(form => {
            this.acumulateFormularios[this.formSelect] = form;
            form.sub_formas.forEach(subForm => {
              if (subForm.alias &&
                  subForm.alias !== '' &&
                  (!subForm.tabla ||
                   (this.typeControl.nombre === 'number' ||
                    this.typeControl.nombre === 'text' ||
                    this.typeControl.nombre === 'textarea'
                   )
                  )
              ) {
                this.formularios.push({
                  key: subForm.alias,
                  value: subForm.alias,
                });
              }
            });
            this.options['formularios'] = this.formularios;
            if (update) {
              this.refreshFormCondiction();
            } else {
              this.getFieldForm();
            }
          });
        } else {
          formularioSeleted.sub_formas.forEach(subForm => {
            if (subForm.alias &&
                subForm.alias !== '' &&
                (!subForm.tabla ||
                 (this.typeControl.nombre === 'number' ||
                  this.typeControl.nombre === 'text' ||
                  this.typeControl.nombre === 'textarea'
                 )
                )
            ) {
              this.formularios.push({
                key: subForm.alias,
                value: subForm.alias,
              });
            }
          });
          this.options['formularios'] = this.formularios;
          if (update) {
            this.refreshFormCondiction();
          } else {
            this.getFieldForm();
          }
        }
      } else {
        this.refreshFormCondiction();
      }
    }
  }

  /**
   * Consulta los campos del formulario seleccionado
   *
   * @private
   * @param {boolean} [update=true]
   * @memberof CreationOperationValueComponent
   */
  private getFieldForm(update: boolean = true) {
    this.fields = [];
    delete this.options['field'];
    let formulario: any = find(this.formPrincipal.sub_formas, {alias: this.formularioSelected});
    if (!formulario || this.formSelect !== this.formPrincipal.alias) {
      if (this.acumulateFormularios[this.formSelect]) {
        if (this.acumulateFormularios[this.formSelect]['sub_formas']) {
          formulario = find(this.acumulateFormularios[this.formSelect]['sub_formas'], {alias: this.formularioSelected});
        }
      }
    }
    if (formulario && formulario.campos && formulario.campos.length) {
      formulario.campos.forEach((field: Control) => {
        if (field.alias && field.alias !== '') {
          if (this.typeControl.nombre === 'number') {
            if (
              field.tipo_campo.nombre === this.typeControl.nombre ||
              field.tipo_campo.nombre === 'date-time-picker'
            ) {
              this.fields.push({
                key: field.alias,
                value: field.alias,
              });
            }
          } else if (
            this.typeControl.nombre === 'text' ||
            this.typeControl.nombre === 'textarea'
          ) {
            if (
              field.tipo_campo.nombre !== 'password' &&
              field.tipo_campo.nombre !== 'label' &&
              field.tipo_campo.nombre !== 'coordenadas'
            ) {
              this.fields.push({
                key: field.alias,
                value: field.alias,
              });
            } else if ( field.tipo_campo.nombre === 'coordenadas') {
              this.fields.push({
                key: field.alias + '_latitud',
                value: 'c:' + field.alias + '_latitud',
              });
              this.fields.push({
                key: field.alias + '_longitud',
                value: 'c:' + field.alias + '_longitud',
              });
              this.fields.push({
                key: field.alias + '_altura',
                value: 'c:' + field.alias + '_altura',
              });
            }
          } else if (this.typeControl.nombre === 'date-time-picker') {
            if (
              field.tipo_campo.nombre === this.typeControl.nombre ||
              field.tipo_campo.nombre === 'number'
            ) {
              this.fields.push({
                key: field.alias,
                value: field.alias,
              });
            }
          } else {
            if (field.tipo_campo.nombre === this.typeControl.nombre) {
              this.fields.push({
                key: field.alias,
                value: field.alias,
              });
            }
          }
        }
      });
    }
    this.options['field'] = this.fields;
    if (update) {
      this.refreshFormCondiction();
    }
  }


  /**
   * Refresca el formulario de agregar valores y referencias para ejecutar los cambios en los selects
   *
   * @private
   * @memberof CreationOperationValueComponent
   */
  private refreshFormCondiction() {
    this.controls = this.covfs.getOperaction(
      this.ngSelectTpl,
      this.options,
      this.typeControl,
      this.tmpControlOperationsValue
    );
    delete this.tmpControlOperationsValue;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/conditions/operations-condition-form/creation-operation-condition/creation-operation-condition-value/creation-operation-condition-value.component.ts